import { useCallback, useEffect, useMemo, useState } from "react";
import { DashboardService } from "../../../../../services/dashboard";
import { useFormatData } from "./useFormatData";

export const useFetchData = (
  granularity: number,
  source: 1 | 2,
  isRecalculated: boolean,
) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [data, setData] = useState<any>([]);

  const { formatData } = useFormatData(granularity);

  const kpiCodes: string[] = useMemo(() => {
    const postfix: string =
      granularity === 1
        ? "CountToday"
        : granularity === 2
          ? "CountThisMonth"
          : "CountThisYear";

    return source === 1
      ? [
          `Payments.Methods.ACH.${postfix}`,
          `Payments.Methods.ECheck.${postfix}`,
          `Payments.Methods.Check.${postfix}`,
          `Payments.Methods.CreditCard.${postfix}`,
          `Payments.Methods.FromImpound.${postfix}`,
          `Payments.Methods.FromEscrow.${postfix}`,
          `Payments.Methods.External.${postfix}`,
        ]
      : [
          `Disbursements.Methods.AchChecking.${postfix}`,
          `Disbursements.Methods.AchSaving.${postfix}`,
          `Disbursements.Methods.Check.${postfix}`,
          `Disbursements.Methods.WireTransfer.${postfix}`,
          `Disbursements.Methods.GeneralLedger.${postfix}`,
          `Disbursements.Methods.ToEscrow.${postfix}`,
        ];
  }, [granularity, source]);

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);

      const res: any = await DashboardService.fetchHistory({
        granularity,
        kpiCodes,
      });

      setData(formatData(res));

      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  }, [formatData, granularity, kpiCodes]);

  useEffect(() => {
    fetchData();
  }, [fetchData, isRecalculated]);

  return { isLoading, data };
};
